module.exports = __webpack_public_path__ + "static/media/loading-bars.b8f8bf93.svg";